export const constant = {
	selector: {
		target: '.js-dropdown-tippy',
		handleButton: '.js-dropdown-tippy-button',
		content: '.js-dropdown-tippy-content',
		contentItem: '.js-dropdown-tippy-content-item',
	},
	attributes: {
		link: 'data-link',
		value: 'data-value',
		global: 'data-global',
	},
	class: {
		dropdownGlobalComponent: 'global-dropdown',
	},
}
